import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectOriginDTOSubtype } from 'flow/selectors/TicketsSelectors';
import { PremadeAnswer } from 'flow/types/Chats';
import { TicketKey } from 'flow/types/EntityKeys';
import PremadeAnswerButton from './PremadeAnswerButton';
import SuggestedTagsButton from './SuggestedTagsButton';
import SummaryButton from './SummaryButton';
import WhatsAppTemplatesButton from './WhatsApp/WhatsAppTemplatesButton';

const extraButtonChannels = ['whatsapp', 'email'];

interface Props {
    ticketKey: TicketKey;
    displayExternalReplyActions: boolean;
    onSelectPremadeAnswer?: (answer: PremadeAnswer) => void;
}

const ExtraButtons = ({
    ticketKey,
    displayExternalReplyActions,
    onSelectPremadeAnswer,
}: Props) => {
    const originSubtype = useAppSelector((state) =>
        selectOriginDTOSubtype(state, ticketKey),
    );

    if (!extraButtonChannels.includes(originSubtype)) {
        return null;
    }

    return (
        <div className="flex items-center gap-3">
            <SummaryButton ticketKey={ticketKey} />
            <SuggestedTagsButton
                ticketKey={ticketKey}
                segmentContext="Ticket footer"
            />
            {originSubtype === 'whatsapp' && (
                <WhatsAppTemplatesButton
                    ticketKey={ticketKey}
                    disabled={!displayExternalReplyActions}
                />
            )}
            {originSubtype === 'email' && onSelectPremadeAnswer && (
                <PremadeAnswerButton
                    ticketKey={ticketKey}
                    disabled={!displayExternalReplyActions}
                    onSelectAnswer={onSelectPremadeAnswer}
                />
            )}
        </div>
    );
};

export default React.memo(ExtraButtons);
